<template>
  <index></index>
</template>


<script>
  import Index from './IndexMain.vue'
  
  export default {
    name: 'leftSidebar',
    components: {
      Index
    }
  }
</script>



// WEBPACK FOOTER //
// Index.vue?63bbd4e9